import React, { useEffect, useState } from "react";
import classNames from "classnames";

import { ArrowIcon } from "../svg";

import styles from "./styles.module.scss";

export const Accordion: React.FC<components.Accordion> = ({
  title,
  className,
  analytics,
  isExpanded = false,
  children,
  toggleEvent,
}) => {
  const [expanded, setExpanded] = useState(false);
  const toggleAccordion = (): void => setExpanded(!expanded);

  useEffect(() => {
    setExpanded(isExpanded);
  }, [isExpanded]);

  return (
    <div className={className}>
      <div
        role="button"
        onClick={toggleEvent || toggleAccordion}
        tabIndex={0}
        onKeyPress={toggleEvent || toggleAccordion}
        data-testid="milestone"
        className={styles.itemContent}
        data-analytics-link={analytics}
      >
        {title}
        <ArrowIcon className={classNames(styles.arrowIcon, { [styles.expandedArrowIcon]: expanded })} />
      </div>
      <div
        className={classNames(styles.accordionContent, {
          [styles.expandedContent]: expanded,
        })}
      >
        {children}
      </div>
    </div>
  );
};
